import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import emailIcon from 'vectors/email.svg';
import facebookIcon from 'vectors/facebook_alt.svg';
import linkedinIcon from 'vectors/linkedin_alt.svg';
import twitterIcon from 'vectors/twitter_alt.svg';
import { type ShareProvider } from '../StreamDashboard.types';
import '../locales/streamDashboard/streamDashboard-en.json';

/*
    The 4 share buttons on the completion screen. They use the legacy completion assets, not the fa-no-block-*
    glyphs on the dashboard rail.
*/

const PROVIDERS: { provider: ShareProvider; icon: string; labelKey: string; color: string }[] = [
    { provider: 'facebook', icon: facebookIcon, labelKey: 'share', color: 'bg-blue-facebook' },
    { provider: 'linkedin', icon: linkedinIcon, labelKey: 'share', color: 'bg-blue-linkedin' },
    { provider: 'twitter', icon: twitterIcon, labelKey: 'tweet', color: 'bg-blue-twitter' },
    { provider: 'email', icon: emailIcon, labelKey: 'email', color: 'bg-dark-grey' },
];

type Props = {
    onShare: (provider: ShareProvider) => void;
    className?: string;
};

export const CompletionShareButtons: FC<Props> = ({ onShare, className }) => {
    const { t } = useTranslation('back_royal', { keyPrefix: 'streamDashboard.streamDashboard' });

    return (
        <div className={twMerge('flex max-w-[300px] flex-wrap justify-center', className)}>
            {PROVIDERS.map(({ provider, icon, labelKey, color }) => (
                <button
                    key={provider}
                    type="button"
                    onClick={() => onShare(provider)}
                    className={twMerge(
                        'm-1 flex h-7.5 w-[140px] items-center gap-2 rounded-3 px-2.5',
                        'text-md font-bold text-white sm:h-10 sm:text-xl',
                        color,
                    )}
                >
                    <img src={icon} alt="" className="h-4.5 w-4.5 shrink-0 sm:h-7.5 sm:w-7.5" />
                    {t(labelKey)}
                </button>
            ))}
        </div>
    );
};
